import dayjs from 'dayjs';
import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

const GRACE_MARGIN = 10_000;

export const useCodeStore = create(
  devtools(
    persist(
      (set) => ({
        previousName: '',
        previousDob: '',
        expiresAt: 0,
        resetExpiresAt: (expires, name, dob) =>
          set(
            (current) => {
              const expiresAt = dayjs(expires).valueOf();
              return {
                previousName: name ?? current.previousName,
                previousDob: dob ?? current.previousDob,
                expiresAt: expiresAt - GRACE_MARGIN,
                validityMinutes: Math.round((expiresAt - Date.now()) / 60_000),
              };
            },
            false,
            'EXPIRE/SET',
          ),
      }),
      {
        name: 'otp-timer-storage',
        partialize: (state) => ({
          previousName: state.previousName,
          previousDob: state.previousDob,
          expiresAt: state.expiresAt,
        }),
      },
    ),
    { name: 'CodeStore' },
  ),
);
